import { makeAutoObservable } from "mobx";
import { MatchUser } from "../models/api/MatchUser";
import { ProgStatus } from "../models/utilTypes";
import ApiService from "../services/ApiService";
import Logger from "../services/Logger";

export class MatchDetailsStore{

    loadingProg: ProgStatus = 'INIT'
    user: MatchUser|null = null
    matchUid: string

    constructor(matchUid: string){
        makeAutoObservable(this)

        this.matchUid = matchUid
    }

    loadMatch(){

        if(this.user)
         return

        this.loadingProg = 'LOADING'

        ApiService.fetchMatchUser(this.matchUid)
            .then(resp =>{
                this.user = resp.data.user
                this.loadingProg = 'SUCCESS'
            })
            .catch(err =>{
                Logger.err(err)
            })
    }
}